import { gql } from '@apollo/client';
export const AUTOMATICSTATETRANSITION_SAVE_SUBSCRIPTION = gql`
  subscription AutomaticStateTransitionUpdated {
    automaticStateTransitionUpdated {
      automaticStateTransition {
        automaticStateTransitionId
        documentTypeId
        fromStateId
        inactive
        automaticStateTransitionRules {
          automaticStateTransitionId
          automaticStateTransitionRuleId
          formula
          orderNo
          toStateId
        }
      }
    }
  }
`;
export const AUTOMATICSTATETRANSITIONRULE_SAVE_SUBSCRIPTION = gql`
  subscription AutomaticStateTransitionRuleUpdated {
    automaticStateTransitionRuleUpdated {
      automaticStateTransitionRule {
        automaticStateTransitionId
        automaticStateTransitionRuleId
        toStateId
        formula
        orderNo
      }
    }
  }
`;

export const AUTOMATICSTATETRANSITIONRULE_DELETE_SUBSCRIPTION = gql`
  subscription automaticStateTransitionRuleDeleted {
    automaticStateTransitionRuleDeleted {
      automaticStateTransitionRuleId
    }
  }
`;
